export const largeMargin = '60px';
export const mediumMargin = '30px';
export const smallMargin = '15px';
export const gutter = `15px`;



// WEBPACK FOOTER //
// ./app/margins.js